/**
 * @voltxampere/spice — Parser error types
 *
 * Sprint 16. The lexer and parser surface user-facing errors with
 * line/column information so dialog UIs can highlight the offending
 * token. Element codecs raise `CodecError` for shape mismatches that
 * occur after the AST is well-formed (wrong node count, unparseable
 * value suffix, etc.).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
/** Surface error for parse failures — raised when we cannot continue. */
export class SpiceParseError extends Error {
    issues;
    name = "SpiceParseError";
    constructor(message, issues) {
        super(message);
        this.issues = issues;
    }
}
/** Codec layer error — wrong shape after the AST built. Carries position. */
export class CodecError extends Error {
    position;
    name = "CodecError";
    constructor(message, position) {
        super(message);
        this.position = position;
    }
}
export function makeIssue(code, message, position) {
    return { code, message, line: position.line, col: position.col };
}
//# sourceMappingURL=errors.js.map